<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link v-if= "authenticated" to="/login" v-on:click.native= "logout()" replace>Logout</router-link> -->
    </div>
    <router-view />
  </div>
</template>





<style lang="css">
#app {
  font-family: "Overpass", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  background-color: black;
}
</style>

<script>
// import jquery from "jquery";
// import '/assets/js/jquery.dataTables';
// window.$ = require("jquery");
// window.JQuery = require("jquery");
export default {
  name: "App",
  data() {
    return {
      authenticated: this.$store.state.token,
      mockAccount: {
        username: "admin",
        password: "password"
      }
    };
  },
  methods: {
    setAuthenticated(status) {
      localStorage.authenticated = status;
    },
    backbuttonClick() {
      this.$store.dispatch("removeToken");
    },
    logout() {
      localStorage.authenticated = false;
    },
    created() {
      document.addEventListener("backbutton", this.backbuttonClick, false);
    },
    beforeDestroy() {
      document.removeEventListener("backbutton", this.backbuttonClick);
    }
  }
};
</script>